export function injectSurveyAnswerLoop(html: string, surveyId: string): string {
  // Match any opening tag that has id="ce-survey-answers" as an attribute,
  // then capture the tag name so we can match the corresponding closing tag.
  const openTagRegex = /<([a-zA-Z][a-zA-Z0-9]*)[^>]*\bid="ce-survey-answers"[^>]*>/;
  const match = openTagRegex.exec(html);
  if (!match) return html;

  const tagName = match[1];
  const openTag = match[0];
  const openIndex = match.index;

  // Find the matching closing tag after the opening tag.
  // This naive indexOf() search is safe because Unlayer rows do not nest elements
  // of the same tag type—each anchor element is a single-level container.
  const closeTag = `</${tagName}>`;
  const closeIndex = html.indexOf(closeTag, openIndex + openTag.length);
  if (closeIndex === -1) return html;

  const afterClose = closeIndex + closeTag.length;

  const before = html.slice(0, openIndex);
  const inner = html.slice(openIndex, afterClose);
  const after = html.slice(afterClose);

  const processedInner = inner
    .replace(/\[survey_title\]/g, "{{this.question}}")
    .replace(/\[survey_answer\]/g, "{{this.answer}}");

  // Strip any additional survey_answers blocks that appear after the first one.
  const cleanedAfter = stripSurveyAnswerBlocksFromHtml(after);

  return `${before}{{#each survey_result_${surveyId}}}${processedInner}{{/each}}${cleanedAfter}`;
}

function stripSurveyAnswerBlocksFromHtml(html: string): string {
  const openTagRegex = /<([a-zA-Z][a-zA-Z0-9]*)[^>]*\bid="ce-survey-answers"[^>]*>/;
  let result = html;
  let match: RegExpExecArray | null;
  while ((match = openTagRegex.exec(result)) !== null) {
    const tagName = match[1];
    const openTag = match[0];
    const openIndex = match.index;
    const closeTag = `</${tagName}>`;
    const closeIndex = result.indexOf(closeTag, openIndex + openTag.length);
    if (closeIndex === -1) break;
    const afterClose = closeIndex + closeTag.length;
    result = result.slice(0, openIndex) + result.slice(afterClose);
  }
  return result;
}
